<div class="container-fluid modal">
  <div class="modal-content run-read-content p-1 p-4">
    <div class="row g-0 m-0 pb-3 align-items-center">
      <div class="col-11 d-flex justify-content-start">
        <h5 class="popup-title m-0">{{ "RUN_READ" | translate }}</h5>
      </div>
      <div class="col-1 d-flex justify-content-end close-btn" (click)="close()">
        <svg-icon alt="Exit" class="exit" role="button" src="assets/device/exit.svg"></svg-icon>
      </div>
    </div>

    @if (isLoading) {
    <div class="initialization-container">
      <div class="initialization-text">{{ "READING_IN_PROGRESS" | translate }}</div>
      <div class="loading-dots">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
    </div>
    }

    @if (isFailed) {
    <div class="error-container">
      <span class="error-msg">{{ errorMessage || ("READ_FAILED" | translate) }}</span>
    </div>
    }

    @if (status === CommandStatus.Success && !reading) {
    <div class="body">
      <div class="row g-0 m-0 info-row">
        <div class="col-md-6 d-flex justify-content-start">
          <span class="item-name">{{ "TIME" | translate }}</span>
        </div>
        <div class="col-md-6 d-flex justify-content-start">
          <span class="item-info">{{ noDataAt | date: 'dd MMM yyyy, h:mm a' }}</span>
        </div>
      </div>
    </div>
    <div class="no-data-container">{{ "NO_NEW_DATA" | translate }}</div>
    }

    @if (status === CommandStatus.Success && reading) {
    <div class="body">
      <div class="reading-block">
        <div class="row g-0 m-0 info-row">
          <div class="col-md-6 d-flex justify-content-start">
            <span class="item-name">{{ "TIME" | translate }}</span>
          </div>
          <div class="col-md-6 d-flex justify-content-start">
            <span class="item-info">{{ reading.meterTime | date: 'dd MMM yyyy, h:mm a' }}</span>
          </div>
        </div>

        <div class="row g-0 m-0 info-row">
          <div class="col-md-6 d-flex justify-content-start">
            <span class="item-name">{{ "ACTIVE_ENERGY_KWH" | translate }}</span>
          </div>
          <div class="col-md-6 d-flex justify-content-start values">
            <span class="value-tag"><img alt="Import" src="assets/load-profile/im.svg" />{{ reading.activeEnergyImport == null ? ("N_A" | translate) : (reading.activeEnergyImport | unitConverter: 'WH') }}</span>
            <span class="value-tag"><img alt="Export" src="assets/load-profile/ex.svg" />{{ reading.activeEnergyExport == null ? ("N_A" | translate) : (reading.activeEnergyExport | unitConverter: 'WH') }}</span>
          </div>
        </div>

        <div class="row g-0 m-0 info-row">
          <div class="col-md-6 d-flex justify-content-start">
            <span class="item-name">{{ "REACTIVE_ENERGY_KVARH" | translate }}</span>
          </div>
          <div class="col-md-6 d-flex justify-content-start values">
            <span class="value-tag"><img alt="Import" src="assets/load-profile/im.svg" />{{ reading.reactiveEnergyImport == null ? ("N_A" | translate) : (reading.reactiveEnergyImport | unitConverter: 'VARH') }}</span>
            <span class="value-tag"><img alt="Export" src="assets/load-profile/ex.svg" />{{ reading.reactiveEnergyExport == null ? ("N_A" | translate) : (reading.reactiveEnergyExport | unitConverter: 'VARH') }}</span>
          </div>
        </div>

        <div class="row g-0 m-0 info-row">
          <div class="col-md-6 d-flex justify-content-start">
            <span class="item-name">{{ "APPARENT_ENERGY_KVAH" | translate }}</span>
          </div>
          <div class="col-md-6 d-flex justify-content-start values">
            <span class="value-tag"><img alt="Import" src="assets/load-profile/im.svg" />{{ reading.apparentEnergyImport == null ? ("N_A" | translate) : (reading.apparentEnergyImport | unitConverter: 'VAH') }}</span>
            <span class="value-tag"><img alt="Export" src="assets/load-profile/ex.svg" />{{ reading.apparentEnergyExport == null ? ("N_A" | translate) : (reading.apparentEnergyExport | unitConverter: 'VAH') }}</span>
          </div>
        </div>

        <div class="row g-0 m-0 info-row">
          <div class="col-md-6 d-flex justify-content-start">
            <span class="item-name">{{ "INSTANTANEOUS_VOLTAGE_V" | translate }}</span>
          </div>
          <div class="col-md-6 d-flex justify-content-start values">
            <span class="value-tag"><img alt="Line 1" src="assets/load-profile/l1.svg" />{{ reading.instantaneousVoltageL1 == null ? ("N_A" | translate) : (reading.instantaneousVoltageL1 | number: '1.0-4') }}</span>
            <span class="value-tag"><img alt="Line 2" src="assets/load-profile/l2.svg" />{{ reading.instantaneousVoltageL2 == null ? ("N_A" | translate) : (reading.instantaneousVoltageL2 | number: '1.0-4') }}</span>
            <span class="value-tag"><img alt="Line 3" src="assets/load-profile/l3.svg" />{{ reading.instantaneousVoltageL3 == null ? ("N_A" | translate) : (reading.instantaneousVoltageL3 | number: '1.0-4') }}</span>
          </div>
        </div>

        <div class="row g-0 m-0 info-row">
          <div class="col-md-6 d-flex justify-content-start">
            <span class="item-name">{{ "INSTANTANEOUS_CURRENT_A" | translate }}</span>
          </div>
          <div class="col-md-6 d-flex justify-content-start values">
            <span class="value-tag"><img alt="Line 1" src="assets/load-profile/l1.svg" />{{ reading.instantaneousCurrentL1 == null ? ("N_A" | translate) : (reading.instantaneousCurrentL1 | number: '1.0-4') }}</span>
            <span class="value-tag"><img alt="Line 2" src="assets/load-profile/l2.svg" />{{ reading.instantaneousCurrentL2 == null ? ("N_A" | translate) : (reading.instantaneousCurrentL2 | number: '1.0-4') }}</span>
            <span class="value-tag"><img alt="Line 3" src="assets/load-profile/l3.svg" />{{ reading.instantaneousCurrentL3 == null ? ("N_A" | translate) : (reading.instantaneousCurrentL3 | number: '1.0-4') }}</span>
          </div>
        </div>

        <div class="row g-0 m-0 info-row">
          <div class="col-md-6 d-flex justify-content-start">
            <span class="item-name">{{ "POWER_FACTOR" | translate }}</span>
          </div>
          <div class="col-md-6 d-flex justify-content-start values">
            <span class="value-tag"><img alt="Line 1" src="assets/load-profile/l1.svg" />{{ reading.instantaneousPowerFactorL1 == null ? ("N_A" | translate) : (reading.instantaneousPowerFactorL1 | number: '1.0-4') }}</span>
            <span class="value-tag"><img alt="Line 2" src="assets/load-profile/l2.svg" />{{ reading.instantaneousPowerFactorL2 == null ? ("N_A" | translate) : (reading.instantaneousPowerFactorL2 | number: '1.0-4') }}</span>
            <span class="value-tag"><img alt="Line 3" src="assets/load-profile/l3.svg" />{{ reading.instantaneousPowerFactorL3 == null ? ("N_A" | translate) : (reading.instantaneousPowerFactorL3 | number: '1.0-4') }}</span>
          </div>
        </div>

        <div class="row g-0 m-0 info-row">
          <div class="col-md-6 d-flex justify-content-start">
            <span class="item-name">{{ "FREQUENCY_HZ" | translate }}</span>
          </div>
          <div class="col-md-6 d-flex justify-content-start">
            <span class="value-tag">{{ reading.instantaneousFrequency == null ? ("N_A" | translate) : (reading.instantaneousFrequency | number: '1.0-4') }}</span>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</div>
